export const rol_captura_config_fechas = [
    "OBSERVADORES11.ADMIN.PARAM.CAPTURA.OC",
    "OBSERVADORES11.ADMIN.CAPTURA.OC",
];

export const rol_cau_config_fechas = [
    "OBSERVADORES11.CAU.OC", //Cau
];
